import baseScmService from 'services/baseScmService';

const crashCourseBatchService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    associateMenteeToBatch: build.mutation({
      query: ({
        superBatchId,
        emails,
        completedClassesStatus,
        upcomingClassesStatus,
        sequence,
        moduleRepeat,
      }) => ({
        url: `/mentee-batch-associations/bulk-create`,
        method: 'POST',
        body: {
          mentee_batch_associations: {
            super_batch_id: superBatchId,
            emails,
            sequence,
            completed_classes_status: completedClassesStatus,
            upcoming_classes_status: upcomingClassesStatus,
            module_repeat: moduleRepeat,
          },
        },
      }),
      invalidatesTags: (result, error) =>
        error ? [] : [{ type: 'SuperBatch' }],
    }),
    dissociateMenteeToBatch: build.mutation({
      query: ({
        superBatchId,
        emails,
        completedClassesStatus,
        upcomingClassesStatus,
      }) => ({
        url: `/mentee-batch-associations/bulk-remove`,
        method: 'POST',
        body: {
          mentee_batch_associations: {
            super_batch_id: superBatchId,
            emails,
            completed_classes_status: completedClassesStatus,
            upcoming_classes_status: upcomingClassesStatus,
          },
        },
      }),
      invalidatesTags: (result, error) =>
        error ? [] : [{ type: 'SuperBatch' }],
    }),
  }),
});

export const {
  useAssociateMenteeToBatchMutation,
  useDissociateMenteeToBatchMutation,
} = crashCourseBatchService;

export default crashCourseBatchService;
